import { useMediaQuery, useTheme } from "@mui/material";
import React, { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { ProjectSearchType } from "../../../../api/psc";
import { defaultLimit } from "../../../../constants/GlobalConstants";
import { DialogContext } from "../../../../contexts/DialogueContext";
import { RootState } from "../../../../slices/Store";
import {
    FetchProjects,
    setProjectsFilter,
    setProjectsPage,
} from "../../slice/ProjectSlice";
// Components
import ProjectDetailDialog from "../../../project-detail/ProjectDetailDialog";
import GoToPageDialog from "../../dialogs/GoToPageDialog";
import ProjectsView from "./ProjectsView";

export default function ProjectsContainer() {
    //
    const dispatch = useDispatch();
    const projectState = useSelector((state: RootState) => state.projects);

    const { openDialog } = useContext(DialogContext);

    const theme = useTheme();
    const isSmallOrDownScreen = useMediaQuery(theme.breakpoints.down("md"));

    let { id } = useParams();

    useEffect(() => {
        fetch();

    }, [projectState.id]);

    useEffect(() => {
        if (id) {
            openDialog(<ProjectDetailDialog projectHashId={id} />);
        }
    }, [id]);

    const fetch = async () => {
        FetchProjects(projectState, dispatch);
    };

    const handlePageChange = async (
        event: React.ChangeEvent<unknown>,
        page: number
    ) => {
        dispatch(setProjectsPage(page - 1));
        window.scroll({ top: 0, left: 0, behavior: "smooth" });
    };

    const onProjectTypeChange = (type: ProjectSearchType) => {
        dispatch(setProjectsFilter({ ...projectState.filter, type: type }));
    };

    const openGoToPage = () => {
        openDialog(
            <GoToPageDialog
                current={projectState.page + 1}
                max={Math.ceil(projectState.totalCount / defaultLimit)}
                onChange={(page) => {
                    dispatch(setProjectsPage(page - 1));
                    window.scroll({ top: 0, left: 0, behavior: "smooth" });
                }}
            />
        );
    };

    return (
        <ProjectsView
            fetch={fetch}
            handlePageChange={handlePageChange}
            isSmallOrDownScreen={isSmallOrDownScreen}
            onProjectTypeChange={onProjectTypeChange}
            openGoToPage={openGoToPage}
            projectState={projectState}
        />
    );
}
